import React from 'react'
import ChartCard from 'dashboard/chart-card'
import { datasetSourcePath } from 'helpers/utils'
import { ASK_CHART_ADAPTER } from './chart-adapter'

// One chart the assistant drew, rendered inline with the same card the report builder uses. It
// fetches its own data from /report_charts/:id/data, so it always shows the data as it is now.
const sourceHref = (dataset) =>
  datasetSourcePath(dataset && { ...dataset, section: { name: dataset.section_name } })

const AskChart = ({ chart, reportId }) => {
  const dataset = chart.dataset
  const dataSources = dataset
    ? [{ id: dataset.id, label: dataset.label, sectionId: dataset.section_id, dashboardId: dataset.dashboard_id, isSample: dataset.is_sample }]
    : []

  return (
    <div className="mb-3" data-testid={`ask-chart-${chart.id}`}>
      <ChartCard
        chart={chart}
        adapter={ASK_CHART_ADAPTER}
        containerId={reportId}
        sectionId={dataset?.section_id}
        params={{}}
        dataSources={dataSources}
        dataSourceId={chart.report_dataset_id}
        dataSourceLabel={dataset?.label ?? null}
        dataSourceHref={sourceHref(dataset)}
        dataSourceMissing={!dataset}
        groupingDashboardId={dataset?.dashboard_id ?? null}
        canEdit={false}
        isPreviewMode={true}
      />
    </div>
  )
}

export default AskChart
